
// 获取编号规则列表
const codeRuleList = async (params = {}, that) => {
  return await that.$system.commonApi("get", "/systematic/code-rule-list-1", params, that, true);
};
// 获取编号规则信息
const codeRuleDetail = async (params = {}, that) => {
  return await that.$system.commonApi("get", "/systematic/code-rule-detail-1", params, that, true);
};
// 保存编号规则信息
const codeRuleSave = async (params = {}, that) => {
  return await that.$system.commonApi("postJson", "/systematic/code-rule-save-1", params, that, true);
};
// 删除编号规则信息
const codeRuleDelete = async (params = {}, that) => {
  return await that.$system.commonApi("postJson", "/systematic/code-rule-delete-1", params, that, true);
};


// 枚举
const CodeEnum = {
  // 额外编号类型
  EXTRA_CODE_TYPE_LIST: [
    { label: "无", value: 0 },
    { label: "年份(YYYY)", value: 1 },
    { label: "日期(YYYYMMDD)", value: 2 },
    { label: "行政区划代码(4位)", value: 3 },
    { label: "行政区划代码(6位)", value: 4 }
  ]
};

export default {
  codeRuleList,
  codeRuleDetail,
  codeRuleSave,
  codeRuleDelete,
  CodeEnum
};
